import { t } from "@travily/i18n";
import { Icon } from "@ui/components/Icon/Icon";
import { Sheet } from "@ui/primitives/Sheet";
import { surfaceCloseButton } from "./sheet-chrome.styles";

export interface SurfaceCloseButtonProps {
  className?: string;
  /** Accessible name. Defaults to the shared "Close" label. */
  "aria-label"?: string;
  /**
   * Press handler for close controls that manage open state themselves.
   * When omitted, the button dispatches the sheet's dismiss action.
   */
  onPress?: () => void;
}

/**
 * The dialog close (X) affordance: a 44px round icon button, negative-margined
 * so its glyph optically aligns with the dialog's content edge. Use inside any
 * Dialog for custom headers (e.g. tab bars that double as the header); pass
 * `className` margins/positioning overrides where the default placement
 * doesn't fit.
 */
export function SurfaceCloseButton({ className, "aria-label": ariaLabel, onPress }: SurfaceCloseButtonProps) {
  const label = ariaLabel ?? t("common.actions.close");
  const classes = surfaceCloseButton({ className });

  if (onPress) {
    return (
      <button aria-label={label} className={classes} onClick={onPress} type="button">
        <Icon name="exit" size="20" />
      </button>
    );
  }

  return (
    <Sheet.Trigger action="dismiss" aria-label={label} className={classes} type="button">
      <Icon name="exit" size="20" />
    </Sheet.Trigger>
  );
}
